import React, { useCallback } from 'react';
import clsx from 'clsx';
import { StudentPickerItem } from '../../boutique-classroom.types';
import { STUDENT_AVATAR_TONE_COUNT } from '../../boutique-classroom.constants';

interface StudentPickerListProps {
	students: StudentPickerItem[];
	selectedIds: number[];
	onToggle: (studentId: number) => void;
	emptyText?: string;
}

const SUBTITLE_SEPARATOR = ' · ';
const DEFAULT_EMPTY_TEXT = 'Listelenecek öğrenci bulunmuyor.';

function getInitials(fullName: string): string {
	return fullName
		.trim()
		.split(/\s+/)
		.slice(0, 2)
		.map(part => part.charAt(0).toLocaleUpperCase('tr-TR'))
		.join('');
}

export const StudentPickerList: React.FC<StudentPickerListProps> = ({ students, selectedIds, onToggle, emptyText = DEFAULT_EMPTY_TEXT }) => {
	const handleChange = useCallback((studentId: number) => () => onToggle(studentId), [onToggle]);

	if (students.length === 0) {
		return <div className="student-picker student-picker--empty">{emptyText}</div>;
	}

	return (
		<ul
			className="student-picker"
			role="listbox"
			aria-multiselectable="true">
			{students.map(student => {
				const isSelected = selectedIds.includes(student.id);
				return (
					<li
						key={student.id}
						role="option"
						aria-selected={isSelected}>
						<label className={clsx('student-row', { 'student-row--selected': isSelected })}>
							<input
								type="checkbox"
								className="student-row__input"
								checked={isSelected}
								onChange={handleChange(student.id)}
							/>
							<span
								className="student-row__check"
								aria-hidden="true"
							/>
							<span className={clsx('student-row__avatar', `student-row__avatar--tone-${student.id % STUDENT_AVATAR_TONE_COUNT}`)}>{getInitials(student.fullName)}</span>
							<span className="student-row__text">
								<span className="student-row__name">{student.fullName}</span>
								<span className="student-row__meta">
									{student.groupName}
									{SUBTITLE_SEPARATOR}
									{student.schoolName}
								</span>
							</span>
						</label>
					</li>
				);
			})}
		</ul>
	);
};

export default StudentPickerList;
